// src/pages/CartPage.js
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./CartPage.css";

const API_BASE =
  window.location.hostname === "localhost"
    ? "http://localhost/restaurant_api"
    : "https://menu-rtl.ir/restaurant_api";

// مسیر استاندارد عکس
function buildUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${API_BASE}/${path.replace(/^\/+/, "")}`;
}

export default function CartPage() {
  const [cart, setCart] = useState([]);
  const [tableCode, setTableCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("cart")) || [];

    const fixed = saved.map((i) => ({
      ...i,
      image: buildUrl(i.image),
      price: Number(i.price) || 0,
      quantity: Number(i.quantity) || 1,

      // ⭐ فقط فارسی نشان داده شود
      displayName: i.name_fa || i.name || "",
    }));

    setCart(fixed);

    const table = params.get("table");
    if (table) setTableCode(table);
  }, [params]);

  const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const updateQuantity = (id, delta) => {
    const updated = cart.map((item) =>
      item.id === id
        ? { ...item, quantity: Math.max(1, item.quantity + delta) }
        : item
    );
    setCart(updated);
    localStorage.setItem("cart", JSON.stringify(updated));
  };

  const removeItem = (id) => {
    const updated = cart.filter((item) => item.id !== id);
    setCart(updated);
    localStorage.setItem("cart", JSON.stringify(updated));
  };

  const submitOrder = async () => {
    if (cart.length === 0) return alert("سبد خرید خالی است.");
    if (!tableCode) return alert("کد میز مشخص نیست.");

    setLoading(true);

    try {
      const body = {
        table: tableCode,
        items: cart,
        total,
      };

      const res = await fetch(`${API_BASE}/order_submit.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      });

      const raw = await res.text();

      let json;
      try {
        json = JSON.parse(raw);
      } catch {
        const found = raw.match(/\{.*\}/s);
        if (found) json = JSON.parse(found[0]);
      }

      if (json?.success) {
        localStorage.removeItem("cart");
        navigate(`/success?table=${tableCode}`);
      } else {
        alert(json?.message || "خطا در ثبت سفارش");
      }
    } catch (e) {
      console.error("Submit error:", e);
      alert("خطا در ارتباط با سرور.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cart-container">
      <h2 className="text-center">🛒 سبد خرید</h2>

      {cart.length === 0 ? (
        <p className="text-center empty">سبد خرید خالی است.</p>
      ) : (
        <div className="cart-list">
          {cart.map((item) => (
            <div key={item.id} className="cart-item">
              <img src={item.image} alt={item.displayName} />

              <div className="info">
                {/* ⭐ فقط فارسی */}
                <strong>{item.displayName}</strong>

                <p>{item.price.toLocaleString()} تومان</p>

                <div className="qty">
                  <button onClick={() => updateQuantity(item.id, -1)}>−</button>
                  <span>{item.quantity}</span>
                  <button onClick={() => updateQuantity(item.id, 1)}>+</button>
                </div>
              </div>

              <button className="remove" onClick={() => removeItem(item.id)}>
                ✖
              </button>
            </div>
          ))}

          <div className="cart-footer">
            <div className="total">مجموع: {total.toLocaleString()} تومان</div>

            <button
              className="submit-btn"
              onClick={submitOrder}
              disabled={loading}
            >
              {loading ? "در حال ثبت..." : "ثبت سفارش"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
